export const countries = [
  { value: 'Afghanistan', label: 'Afghanistan', dialing_code: '+93' },
  { value: 'Albania', label: 'Albania', dialing_code: '+355' },
  { value: 'Algeria', label: 'Algeria', dialing_code: '+213' },
  { value: 'American Samoa', label: 'American Samoa', dialing_code: '+1684' },
  { value: 'Andorra', label: 'Andorra', dialing_code: '+376' },
  { value: 'Angola', label: 'Angola', dialing_code: '+244' },
  { value: 'Anguilla', label: 'Anguilla', dialing_code: '+1264' },
  { value: 'Antigua and Barbuda', label: 'Antigua and Barbuda', dialing_code: '+1268' },
  { value: 'Argentina', label: 'Argentina', dialing_code: '+54' },
  { value: 'Armenia', label: 'Armenia', dialing_code: '+374' },
  { value: 'Aruba', label: 'Aruba', dialing_code: '+297' },
  { value: 'Australia', label: 'Australia', dialing_code: '+61' },
  { value: 'Austria', label: 'Austria', dialing_code: '+43' },
  { value: 'Azerbaijan', label: 'Azerbaijan', dialing_code: '+994' },
  { value: 'Bahamas', label: 'Bahamas', dialing_code: '+1242' },
  { value: 'Bahrain', label: 'Bahrain', dialing_code: '+973' },
  { value: 'Bangladesh', label: 'Bangladesh', dialing_code: '+880' },
  { value: 'Barbados', label: 'Barbados', dialing_code: '+1246' },
  { value: 'Belarus', label: 'Belarus', dialing_code: '+375' },
  { value: 'Belgium', label: 'Belgium', dialing_code: '+32' },
  { value: 'Belize', label: 'Belize', dialing_code: '+501' },
  { value: 'Benin', label: 'Benin', dialing_code: '+229' },
  { value: 'Bermuda', label: 'Bermuda', dialing_code: '+1441' },
  { value: 'Bhutan', label: 'Bhutan', dialing_code: '+975' },
  { value: 'Bolivia', label: 'Bolivia', dialing_code: '+591' },
  { value: 'Bosnia and Herzegovina', label: 'Bosnia and Herzegovina', dialing_code: '+387' },
  { value: 'Botswana', label: 'Botswana', dialing_code: '+267' },
  { value: 'Brazil', label: 'Brazil', dialing_code: '+55' },
  { value: 'British Indian Ocean Territory', label: 'British Indian Ocean Territory', dialing_code: '+246' },
  { value: 'British Virgin Islands', label: 'British Virgin Islands', dialing_code: '+1284' },
  { value: 'Brunei', label: 'Brunei', dialing_code: '+673' },
  { value: 'Bulgaria', label: 'Bulgaria', dialing_code: '+359' },
  { value: 'Burkina Faso', label: 'Burkina Faso', dialing_code: '+226' },
  { value: 'Burundi', label: 'Burundi', dialing_code: '+257' },
  { value: 'Cambodia', label: 'Cambodia', dialing_code: '+855' },
  { value: 'Cameroon', label: 'Cameroon', dialing_code: '+237' },
  { value: 'Canada', label: 'Canada', dialing_code: '+1' },
  { value: 'Cape Verde', label: 'Cape Verde', dialing_code: '+238' },
  { value: 'Cayman Islands', label: 'Cayman Islands', dialing_code: '+1345' },
  { value: 'Central African Republic', label: 'Central African Republic', dialing_code: '+236' },
  { value: 'Chad', label: 'Chad', dialing_code: '+235' },
  { value: 'Chile', label: 'Chile', dialing_code: '+56' },
  { value: 'China', label: 'China', dialing_code: '+86' },
  { value: 'Christmas Island', label: 'Christmas Island', dialing_code: '+61' },
  { value: 'Cocos Islands', label: 'Cocos Islands', dialing_code: '+61' },
  { value: 'Colombia', label: 'Colombia', dialing_code: '+57' },
  { value: 'Comoros', label: 'Comoros', dialing_code: '+269' },
  { value: 'Cook Islands', label: 'Cook Islands', dialing_code: '+682' },
  { value: 'Costa Rica', label: 'Costa Rica', dialing_code: '+506' },
  { value: 'Croatia', label: 'Croatia', dialing_code: '+385' },
  { value: 'Cuba', label: 'Cuba', dialing_code: '+53' },
  { value: 'Curacao', label: 'Curacao', dialing_code: '+599' },
  { value: 'Cyprus', label: 'Cyprus', dialing_code: '+357' },
  { value: 'Czech Republic', label: 'Czech Republic', dialing_code: '+420' },
  { value: 'Democratic Republic of the Congo', label: 'Democratic Republic of the Congo', dialing_code: '+243' },
  { value: 'Denmark', label: 'Denmark', dialing_code: '+45' },
  { value: 'Djibouti', label: 'Djibouti', dialing_code: '+253' },
  { value: 'Dominica', label: 'Dominica', dialing_code: '+1767' },
  { value: 'Dominican Republic', label: 'Dominican Republic', dialing_code: '+1' },
  { value: 'East Timor', label: 'East Timor', dialing_code: '+670' },
  { value: 'Ecuador', label: 'Ecuador', dialing_code: '+593' },
  { value: 'Egypt', label: 'Egypt', dialing_code: '+20' },
  { value: 'El Salvador', label: 'El Salvador', dialing_code: '+503' },
  { value: 'Equatorial Guinea', label: 'Equatorial Guinea', dialing_code: '+240' },
  { value: 'Eritrea', label: 'Eritrea', dialing_code: '+291' },
  { value: 'Estonia', label: 'Estonia', dialing_code: '+372' },
  { value: 'Ethiopia', label: 'Ethiopia', dialing_code: '+251' },
  { value: 'Falkland Islands', label: 'Falkland Islands', dialing_code: '+500' },
  { value: 'Faroe Islands', label: 'Faroe Islands', dialing_code: '+298' },
  { value: 'Fiji', label: 'Fiji', dialing_code: '+679' },
  { value: 'Finland', label: 'Finland', dialing_code: '+358' },
  { value: 'France', label: 'France', dialing_code: '+33' },
  { value: 'French Polynesia', label: 'French Polynesia', dialing_code: '+689' },
  { value: 'Gabon', label: 'Gabon', dialing_code: '+241' },
  { value: 'Gambia', label: 'Gambia', dialing_code: '+220' },
  { value: 'Georgia', label: 'Georgia', dialing_code: '+995' },
  { value: 'Germany', label: 'Germany', dialing_code: '+49' },
  { value: 'Ghana', label: 'Ghana', dialing_code: '+233' },
  { value: 'Gibraltar', label: 'Gibraltar', dialing_code: '+350' },
  { value: 'Greece', label: 'Greece', dialing_code: '+30' },
  { value: 'Greenland', label: 'Greenland', dialing_code: '+299' },
  { value: 'Grenada', label: 'Grenada', dialing_code: '+1473' },
  { value: 'Guam', label: 'Guam', dialing_code: '+1671' },
  { value: 'Guatemala', label: 'Guatemala', dialing_code: '+502' },
  { value: 'Guernsey', label: 'Guernsey', dialing_code: '+44' },
  { value: 'Guinea', label: 'Guinea', dialing_code: '+224' },
  { value: 'Guinea-Bissau', label: 'Guinea-Bissau', dialing_code: '+245' },
  { value: 'Guyana', label: 'Guyana', dialing_code: '+592' },
  { value: 'Haiti', label: 'Haiti', dialing_code: '+509' },
  { value: 'Honduras', label: 'Honduras', dialing_code: '+504' },
  { value: 'Hong Kong', label: 'Hong Kong', dialing_code: '+852' },
  { value: 'Hungary', label: 'Hungary', dialing_code: '+36' },
  { value: 'Iceland', label: 'Iceland', dialing_code: '+354' },
  { value: 'India', label: 'India', dialing_code: '+91' },
  { value: 'Indonesia', label: 'Indonesia', dialing_code: '+62' },
  { value: 'Iran', label: 'Iran', dialing_code: '+98' },
  { value: 'Iraq', label: 'Iraq', dialing_code: '+964' },
  { value: 'Ireland', label: 'Ireland', dialing_code: '+353' },
  { value: 'Isle of Man', label: 'Isle of Man', dialing_code: '+44' },
  { value: 'Israel', label: 'Israel', dialing_code: '+972' },
  { value: 'Italy', label: 'Italy', dialing_code: '+39' },
  { value: 'Ivory Coast', label: 'Ivory Coast', dialing_code: '+225' },
  { value: 'Jamaica', label: 'Jamaica', dialing_code: '+1876' },
  { value: 'Japan', label: 'Japan', dialing_code: '+81' },
  { value: 'Jersey', label: 'Jersey', dialing_code: '+44' },
  { value: 'Jordan', label: 'Jordan', dialing_code: '+962' },
  { value: 'Kazakhstan', label: 'Kazakhstan', dialing_code: '+7' },
  { value: 'Kenya', label: 'Kenya', dialing_code: '+254' },
  { value: 'Kiribati', label: 'Kiribati', dialing_code: '+686' },
  { value: 'Kosovo', label: 'Kosovo', dialing_code: '+383' },
  { value: 'Kuwait', label: 'Kuwait', dialing_code: '+965' },
  { value: 'Kyrgyzstan', label: 'Kyrgyzstan', dialing_code: '+996' },
  { value: 'Laos', label: 'Laos', dialing_code: '+856' },
  { value: 'Latvia', label: 'Latvia', dialing_code: '+371' },
  { value: 'Lebanon', label: 'Lebanon', dialing_code: '+961' },
  { value: 'Lesotho', label: 'Lesotho', dialing_code: '+266' },
  { value: 'Liberia', label: 'Liberia', dialing_code: '+231' },
  { value: 'Libya', label: 'Libya', dialing_code: '+218' },
  { value: 'Liechtenstein', label: 'Liechtenstein', dialing_code: '+423' },
  { value: 'Lithuania', label: 'Lithuania', dialing_code: '+370' },
  { value: 'Luxembourg', label: 'Luxembourg', dialing_code: '+352' },
  { value: 'Macau', label: 'Macau', dialing_code: '+853' },
  { value: 'Macedonia', label: 'Macedonia', dialing_code: '+389' },
  { value: 'Madagascar', label: 'Madagascar', dialing_code: '+261' },
  { value: 'Malawi', label: 'Malawi', dialing_code: '+265' },
  { value: 'Malaysia', label: 'Malaysia', dialing_code: '+60' },
  { value: 'Maldives', label: 'Maldives', dialing_code: '+960' },
  { value: 'Mali', label: 'Mali', dialing_code: '+223' },
  { value: 'Malta', label: 'Malta', dialing_code: '+356' },
  { value: 'Marshall Islands', label: 'Marshall Islands', dialing_code: '+692' },
  { value: 'Mauritania', label: 'Mauritania', dialing_code: '+222' },
  { value: 'Mauritius', label: 'Mauritius', dialing_code: '+230' },
  { value: 'Mayotte', label: 'Mayotte', dialing_code: '+262' },
  { value: 'Mexico', label: 'Mexico', dialing_code: '+52' },
  { value: 'Micronesia', label: 'Micronesia', dialing_code: '+691' },
  { value: 'Moldova', label: 'Moldova', dialing_code: '+373' },
  { value: 'Monaco', label: 'Monaco', dialing_code: '+377' },
  { value: 'Mongolia', label: 'Mongolia', dialing_code: '+976' },
  { value: 'Montenegro', label: 'Montenegro', dialing_code: '+382' },
  { value: 'Montserrat', label: 'Montserrat', dialing_code: '+1664' },
  { value: 'Morocco', label: 'Morocco', dialing_code: '+212' },
  { value: 'Mozambique', label: 'Mozambique', dialing_code: '+258' },
  { value: 'Myanmar', label: 'Myanmar', dialing_code: '+95' },
  { value: 'Namibia', label: 'Namibia', dialing_code: '+264' },
  { value: 'Nauru', label: 'Nauru', dialing_code: '+674' },
  { value: 'Nepal', label: 'Nepal', dialing_code: '+977' },
  { value: 'Netherlands', label: 'Netherlands', dialing_code: '+31' },
  { value: 'Netherlands Antilles', label: 'Netherlands Antilles', dialing_code: '+599' },
  { value: 'New Caledonia', label: 'New Caledonia', dialing_code: '+687' },
  { value: 'New Zealand', label: 'New Zealand', dialing_code: '+64' },
  { value: 'Nicaragua', label: 'Nicaragua', dialing_code: '+505' },
  { value: 'Niger', label: 'Niger', dialing_code: '+227' },
  { value: 'Nigeria', label: 'Nigeria', dialing_code: '+234' },
  { value: 'Niue', label: 'Niue', dialing_code: '+683' },
  { value: 'North Korea', label: 'North Korea', dialing_code: '+850' },
  { value: 'Northern Mariana Islands', label: 'Northern Mariana Islands', dialing_code: '+1670' },
  { value: 'Norway', label: 'Norway', dialing_code: '+47' },
  { value: 'Oman', label: 'Oman', dialing_code: '+968' },
  { value: 'Pakistan', label: 'Pakistan', dialing_code: '+92' },
  { value: 'Palau', label: 'Palau', dialing_code: '+680' },
  { value: 'Palestine', label: 'Palestine', dialing_code: '+970' },
  { value: 'Panama', label: 'Panama', dialing_code: '+507' },
  { value: 'Papua New Guinea', label: 'Papua New Guinea', dialing_code: '+675' },
  { value: 'Paraguay', label: 'Paraguay', dialing_code: '+595' },
  { value: 'Peru', label: 'Peru', dialing_code: '+51' },
  { value: 'Philippines', label: 'Philippines', dialing_code: '+63' },
  { value: 'Pitcairn', label: 'Pitcairn', dialing_code: '+64' },
  { value: 'Poland', label: 'Poland', dialing_code: '+48' },
  { value: 'Portugal', label: 'Portugal', dialing_code: '+351' },
  { value: 'Puerto Rico', label: 'Puerto Rico', dialing_code: '+1' },
  { value: 'Qatar', label: 'Qatar', dialing_code: '+974' },
  { value: 'Republic of the Congo', label: 'Republic of the Congo', dialing_code: '+242' },
  { value: 'Reunion', label: 'Reunion', dialing_code: '+262' },
  { value: 'Romania', label: 'Romania', dialing_code: '+40' },
  { value: 'Russia', label: 'Russia', dialing_code: '+7' },
  { value: 'Rwanda', label: 'Rwanda', dialing_code: '+250' },
  { value: 'Saint Barthelemy', label: 'Saint Barthelemy', dialing_code: '+590' },
  { value: 'Saint Helena', label: 'Saint Helena', dialing_code: '+290' },
  { value: 'Saint Kitts and Nevis', label: 'Saint Kitts and Nevis', dialing_code: '+1869' },
  { value: 'Saint Lucia', label: 'Saint Lucia', dialing_code: '+1758' },
  { value: 'Saint Martin', label: 'Saint Martin', dialing_code: '+590' },
  { value: 'Saint Pierre and Miquelon', label: 'Saint Pierre and Miquelon', dialing_code: '+508' },
  { value: 'Saint Vincent and the Grenadines', label: 'Saint Vincent and the Grenadines', dialing_code: '+1784' },
  { value: 'Samoa', label: 'Samoa', dialing_code: '+685' },
  { value: 'San Marino', label: 'San Marino', dialing_code: '+378' },
  { value: 'Sao Tome and Principe', label: 'Sao Tome and Principe', dialing_code: '+239' },
  { value: 'Saudi Arabia', label: 'Saudi Arabia', dialing_code: '+966' },
  { value: 'Senegal', label: 'Senegal', dialing_code: '+221' },
  { value: 'Serbia', label: 'Serbia', dialing_code: '+381' },
  { value: 'Seychelles', label: 'Seychelles', dialing_code: '+248' },
  { value: 'Sierra Leone', label: 'Sierra Leone', dialing_code: '+232' },
  { value: 'Singapore', label: 'Singapore', dialing_code: '+65' },
  { value: 'Sint Maarten', label: 'Sint Maarten', dialing_code: '+1721' },
  { value: 'Slovakia', label: 'Slovakia', dialing_code: '+421' },
  { value: 'Slovenia', label: 'Slovenia', dialing_code: '+386' },
  { value: 'Solomon Islands', label: 'Solomon Islands', dialing_code: '+677' },
  { value: 'Somalia', label: 'Somalia', dialing_code: '+252' },
  { value: 'South Africa', label: 'South Africa', dialing_code: '+27' },
  { value: 'South Korea', label: 'South Korea', dialing_code: '+82' },
  { value: 'South Sudan', label: 'South Sudan', dialing_code: '+211' },
  { value: 'Spain', label: 'Spain', dialing_code: '+34' },
  { value: 'Sri Lanka', label: 'Sri Lanka', dialing_code: '+94' },
  { value: 'Sudan', label: 'Sudan', dialing_code: '+249' },
  { value: 'Suriname', label: 'Suriname', dialing_code: '+597' },
  { value: 'Svalbard and Jan Mayen', label: 'Svalbard and Jan Mayen', dialing_code: '+47' },
  { value: 'Swaziland', label: 'Swaziland', dialing_code: '+268' },
  { value: 'Sweden', label: 'Sweden', dialing_code: '+46' },
  { value: 'Switzerland', label: 'Switzerland', dialing_code: '+41' },
  { value: 'Syria', label: 'Syria', dialing_code: '+963' },
  { value: 'Taiwan', label: 'Taiwan', dialing_code: '+886' },
  { value: 'Tajikistan', label: 'Tajikistan', dialing_code: '+992' },
  { value: 'Tanzania', label: 'Tanzania', dialing_code: '+255' },
  { value: 'Thailand', label: 'Thailand', dialing_code: '+66' },
  { value: 'Togo', label: 'Togo', dialing_code: '+228' },
  { value: 'Tokelau', label: 'Tokelau', dialing_code: '+690' },
  { value: 'Tonga', label: 'Tonga', dialing_code: '+676' },
  { value: 'Trinidad and Tobago', label: 'Trinidad and Tobago', dialing_code: '+1868' },
  { value: 'Tunisia', label: 'Tunisia', dialing_code: '+216' },
  { value: 'Turkey', label: 'Turkey', dialing_code: '+90' },
  { value: 'Turkmenistan', label: 'Turkmenistan', dialing_code: '+993' },
  { value: 'Turks and Caicos Islands', label: 'Turks and Caicos Islands', dialing_code: '+1649' },
  { value: 'Tuvalu', label: 'Tuvalu', dialing_code: '+688' },
  { value: 'U.S. Virgin Islands', label: 'U.S. Virgin Islands', dialing_code: '+1340' },
  { value: 'Uganda', label: 'Uganda', dialing_code: '+256' },
  { value: 'Ukraine', label: 'Ukraine', dialing_code: '+380' },
  { value: 'United Arab Emirates', label: 'United Arab Emirates', dialing_code: '+971' },
  { value: 'United Kingdom', label: 'United Kingdom', dialing_code: '+44' },
  { value: 'United States', label: 'United States', dialing_code: '+1' },
  { value: 'Uruguay', label: 'Uruguay', dialing_code: '+598' },
  { value: 'Uzbekistan', label: 'Uzbekistan', dialing_code: '+998' },
  { value: 'Vanuatu', label: 'Vanuatu', dialing_code: '+678' },
  { value: 'Vatican', label: 'Vatican', dialing_code: '+39' },
  { value: 'Venezuela', label: 'Venezuela', dialing_code: '+58' },
  { value: 'Vietnam', label: 'Vietnam', dialing_code: '+84' },
  { value: 'Wallis and Futuna', label: 'Wallis and Futuna', dialing_code: '+681' },
  { value: 'Western Sahara', label: 'Western Sahara', dialing_code: '+212' },
  { value: 'Yemen', label: 'Yemen', dialing_code: '+967' },
  { value: 'Zambia', label: 'Zambia', dialing_code: '+260' },
  { value: 'Zimbabwe', label: 'Zimbabwe', dialing_code: '+263' },
];